import { render } from "./LoadMore.vue?vue&type=template&id=5a7bc5bf&scoped=true"
import script from "./LoadMore.vue?vue&type=script&lang=js"
export * from "./LoadMore.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=5a7bc5bf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7bc5bf"]])

export default __exports__